export const GeneralConfiguration = {
    path: '/general_configuration',
    name: 'general_configuration',
    component: () => import('@/views/Parameter/GeneralConfiguration.vue'),
}